import axios from "axios";
import i18n from "../../languages/INEXT";
import { toast } from "react-toastify";
import { getAccessToken, showSessionExpiredModal } from "../../utils";

const abortController = new AbortController();

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const accessToken = getAccessToken();
  const language = i18n.language;

  config.signal = abortController.signal;

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  if (language) {
    config.headers["X-localization"] = language;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;

      // Handle Bad Requeset errors (e.g., 400 Bad Request)
      if (status === 400) {
        return Promise.reject({
          code: status,
          message: error?.response?.data?.message,
        });
      }

      // Handle unauthorized errors (e.g., 401 Unauthorized)
      if (status === 401) {
        toast.error(i18n.t("unauthorized"));
        localStorage.clear();
        sessionStorage.clear();
        showSessionExpiredModal();
        // abortController.abort();
        // abortController = new AbortController();
        return Promise.reject({
          code: status,
          message: error?.response?.data?.message,
        });
      }

      // Handle forbidden errors (e.g., 403 Forbidden)
      if (status === 403) {
        toast.error(i18n.t("forbidden"));
        return Promise.reject({
          code: status,
          message: error?.response?.data?.message,
        });
      }

      // Handle not found errors (e.g., 404 Not Found)
      if (status === 404) {
        toast.error(i18n.t("notFound"));
        return Promise.reject({
          code: status,
          message: error?.response?.data?.message,
        });
      }

      // Handle Validation errors (e.g., 422 Validation Error)
      if (status === 422) {
        toast.error(error?.response?.data?.message);
        return Promise.reject({
          code: status,
          message: error?.response?.data?.message,
        });
      }

      // Handle server errors (e.g., 500 Internal Server Error)
      if (status === 500) {
        return Promise.reject({
          code: status,
          message: error?.response?.data?.message,
        });
      }
      if (error.code === "ECONNABORTED") {
        // Handle request timeout
        toast.error(i18n.t("timeout"));
        return Promise.reject({
          code: error.code,
          message: i18n.t("timeout"),
        });
      }
    } else {
      // Handle network or other unexpected errors
      return Promise.reject({
        code: error.code,
        message: i18n.t("unknownError"),
      });
    }

    // Fallback rejection if no condition matched
    return Promise.reject(error);
  }
);

export default axiosInstance;
